import React from 'react';
import PropTypes from 'prop-types';

const LoadingScreen = ({ isLoading, progress }) => {
  return (
    <div
      className={`loading-screen ${isLoading ? 'loading-screen--open' : ''}`}
    >
      <div>
        <div className="fadein-element">
          <img
            alt="1"
            src="https://store.royalenfield.com/static/version1592688378/frontend/Royalenfield/royaltheme/en_US/images/pre-loader-01.svg"
          />
          <img
            alt="2"
            src="https://store.royalenfield.com/static/version1592688378/frontend/Royalenfield/royaltheme/en_US/images/pre-loader-02.svg"
          />
          <img
            alt="3"
            src="https://store.royalenfield.com/static/version1592688378/frontend/Royalenfield/royaltheme/en_US/images/pre-loader-03.svg"
          />
          <img
            alt="4"
            src="https://store.royalenfield.com/static/version1592688378/frontend/Royalenfield/royaltheme/en_US/images/pre-loader-04.svg"
          />
          <img
            alt="5"
            src="https://store.royalenfield.com/static/version1592688378/frontend/Royalenfield/royaltheme/en_US/images/pre-loader-05.svg"
          />
        </div>
        <div className="lds-ellipsis">
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className="loading-screen_progress">
          {progress && progress !== 0 ? `${Math.round(progress)}%` : '0%'}
        </div>
      </div>
    </div>
  );
};

LoadingScreen.propTypes = {
  isLoading: PropTypes.bool,
  progress: PropTypes.number
};

export default LoadingScreen;
